import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export function FlaggedBundlesBanner() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/new-catalogue/plan").then((r) => setList(r.data.blocked_list || [])).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  return (
    <div className="mx-6 lg:mx-8 mb-3 rounded-xl border border-rose-200 bg-rose-50 p-3 text-sm" data-testid="flagged-bundles-banner">
      <div className="mb-1 flex items-center gap-2 font-semibold text-rose-800"><AlertTriangle className="w-4 h-4" /> {list.length} bundle{list.length === 1 ? "" : "s"} flagged for correction — open one and click Fix bundle</div>
      <ul className="space-y-0.5">{list.map((b) => (
        <li key={b.legacy_id}><Link to={`/products/${b.legacy_id}`} className="text-rose-800 underline" data-testid={`flagged-bundle-${b.legacy_id}`}>#{b.legacy_id} {b.title}</Link> <span className="text-rose-700">— {b.reasons.join("; ")}</span></li>))}</ul>
    </div>
  );
}
